import Grid from "@material-ui/core/Grid";
import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import Box from '@material-ui/core/Box'
import '../css/aboutme.css';


const AboutMe = () => (
    <div id="about-me">
        {/*ABOUT ME*/}
        <Grid container direction="row" justify="space-evenly" alignItems="center">

            <Grid item xs={4}>
                <ScrollAnimation animateIn='slideInLeft' animateOut='slideOutLeft' duration="1">
                    <h2 className="details">
                        <strong>About me.</strong> <br/><br/>
                        <u>My Work.</u><br/>
                        I can work in Python, Java, HTML, Javascript, CSS and PHP. I have also previously worked with C# and SQL. <br/><br/> I'm from London but
                        currently a student at Loughborough University in my second year, studying Computer Science.<br/><br/> To have a look at my
                        CV, <a className={'cv-link'} href={'https://drive.google.com/file/d/1h_bAfe6fVzW7iKUHmuJ8lDqBqUTU8N8z/view?usp=sharing'}>click here.</a><br/><br/> To have a look at some of my projects, scroll down!
                        <br/> <br/>
                    </h2>
                </ScrollAnimation>
            </Grid>
            <Grid item xs={4}>
                <ScrollAnimation animateIn='slideInRight' animateOut='slideOutRight' duration="1.5">
                    <Box className="aboutMePicture"/>
                </ScrollAnimation>
            </Grid>

        </Grid>
    </div>
);
export default AboutMe;